import { createFileRoute } from '@tanstack/react-router'
import { orgAgreementSearchSchema } from '@/features/org-agreements/filter-org-agreements/model/orgAgreementSearch'
import { OrgAgreementsPage } from '@/pages/agreements/ui/OrgAgreementsPage'

export const Route = createFileRoute('/org-agreements')({
  validateSearch: orgAgreementSearchSchema,
  component: OrgAgreementsPage,
})
